export default __webpack_public_path__ + "static/media/productss.8a3ef43a.png";